import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import * as moment from 'moment';
import { ChangeDetectorStatus } from '@angular/core/src/change_detection/constants';
/**
 * Generated class for the ExcludearmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-excludearm',
  templateUrl: 'excludearm.html',
})
export class ExcludearmPage {

  door = false;
  movement = false;
  panel = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public alertCtrl: AlertController, public pan: GN, public toastCtrl: ToastController) {
    var _that = this
    var _data = this.navParams.get("data")
    var cnt = _data.cnt
    _data = _data.data
    _that.door = _data[0].door + '' == '1' ? true : false;
    _that.movement = _data[0].movement + '' == '1' ? true : false;
    _that.panel = _data[0].panel + '' == '1' ? true : false;
  }

  ionViewDidLoad() {
  }

  emailValidate(value) {
    var izlez;
    if (value == null)
      return izlez;
    var emailovi = value.split(",");
    emailovi.forEach(function (mejl) {
      var filter = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
      izlez = filter.test(mejl.trim());
    });
    console.log(izlez, 'izlez da vidime')
    return izlez;
  }

  saveExcludeArm() {
    var _that = this
    var _vid = this.navParams.get("vid")
    var _excludedata = []
    _excludedata.push({
      door: this.door + '' == 'true' ? '1' : '0',
      movement: this.movement + '' == 'true' ? '1' : '0',
      panel: this.panel + '' == 'true' ? '1' : '0'
    })
    var _that = this;
    this.pan._Post('/api/gn/saveexcludearm', { vid: this.pan.crypt(_vid), excludedata: _excludedata }, function (_data) {
      _that.navCtrl.pop()
      var _changes = []

      var kArr = _excludedata[0]
      var kArr1 = _that.navParams.get("data").data[0]

      for (var k = 0; k < Object.keys(kArr).length; k++) {
        if (kArr[Object.keys(kArr)[k]] + '' != kArr1[Object.keys(kArr1)[k + 1]] + '') {
          _changes.push(Object.keys(kArr)[k] + ' ' + kArr[Object.keys(kArr)[k]])

          var _alarmtypeid = -1
          if (Object.keys(kArr)[k] == "door") _alarmtypeid = 82;
          if (Object.keys(kArr)[k] == "movement") _alarmtypeid = 80;
          if (Object.keys(kArr)[k] == "panel") _alarmtypeid = 81;

          if (_alarmtypeid == -1)
            return

          if (_that.pan.Vehicles[_that.pan.VehiclesDic[_vid]].armed + '' == '1') {
            if (kArr[Object.keys(kArr)[k]] + '' == '1') {
              var _email = ''
              if (_that.emailValidate(_that.pan.user.username))
                _email = _that.pan.user.username
              else {
                _email = _that.pan.user.email
              }
              var dat = {
                alarmtypeid: _that.pan.crypt(_alarmtypeid),
                settings: null,
                available: _that.pan.crypt(3),
                emails: _that.pan.crypt(_email.replace(/ /g, '')),
                sms: '',
                soundid: _that.pan.crypt(1),
                snooze: _that.pan.crypt(_that.pan.user.Snooze),
                clientid: _that.pan.crypt(_that.pan.user.ClientId),
                vehicleid: _that.pan.crypt(_vid),
                speed: _that.pan.crypt(0),
                speedafter: _that.pan.crypt(-1),
                timeofpoi: _that.pan.crypt('-1'),
                poiid: _that.pan.crypt('-1'),
                uniqid: _that.pan.crypt(null),
                typeofgroup: _that.pan.crypt('1'),
                remindme: _that.pan.crypt(''),
                smsviaemail: '',
                rid: _that.pan.crypt(_that.pan.user.RoleId),
                cid: _that.pan.crypt(_that.pan.user.ClientId),
                orgunit: _that.pan.crypt('-1'),
                uid: _that.pan.crypt(_that.pan.user.UserId),
                arm: _that.pan.crypt(1),
                bleslotnum: _that.pan.crypt(-1)
                // speedafter: _that.pan.crypt(_that._speedafter)
              }
              _that.pan._Post('/api/gn/insertalarms', dat, function (_data) {

              })
            } else {
              var dat1 = {
                alarmtypeid: _that.pan.crypt(_alarmtypeid),
                vid: _that.pan.crypt(_vid)
              }
              _that.pan._Post('/api/gn/deletealarmdisarm', dat1, function (_data) {

              })
            }
          }
        }
      }
    })
  }
}









// WEBPACK FOOTER //
// ./src/pages/excludearm/excludearm.ts